exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[data-v-0d040d11]::-webkit-inner-spin-button,input[data-v-0d040d11]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number][data-v-0d040d11]{-moz-appearance:textfield}.tanpawrap[data-v-0d040d11]{white-space:nowrap}", ""]);

// exports
